import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { FieldWrapper, FormlyFieldConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./accordion.component.html",
    styleUrls: ["./accordion.component.css"],
})
export class AccordionComponent extends FieldWrapper {
    @ViewChild("fieldComponent", { read: ViewContainerRef })
    declare fieldComponent: ViewContainerRef;

    onOpen(event: Event) {
        this.props.selected = true;
        if (this.props.change) this.props.change(this.field, event);
        //check if accordion contains any file-upload question/control
        if (this.field.fieldGroup.find(x => x.type == "file-upload") != null)
        {
            //resize p-table columns
            window.dispatchEvent(new Event('resize'));
        }
    }

    // Lets a collapsed section flag that a question inside it (however deeply nested)
    // failed validation. Checks this section's own fields rather than this.formControl:
    // a rollup has no form key, so its formControl is the whole form, which would flag
    // every section whenever any field anywhere in the form is invalid.
    get hasError(): boolean {
        return this.hasInvalidTouchedField(this.field.fieldGroup);
    }

    private hasInvalidTouchedField(fields: FormlyFieldConfig[] = []): boolean {
        return fields.some((field) => {
            if (
                !field ||
                field.hide ||
                field.props?.hidden ||
                field.props?.isLogicallyHidden ||
                field.props?.isParentLogicallyHidden
            ) {
                return false;
            }

            if (field.fieldGroup?.length) {
                return this.hasInvalidTouchedField(field.fieldGroup);
            }

            return !!(field.formControl?.invalid && field.formControl?.touched && !field.props?.loading);
        });
    }
}
